import React from "react"
import styled from "styled-components"
import colors from "styles/colors"
import media from "styles/media"
import text from "styles/text"
import ContentWidth from "components/ContentWidth"
import QuoteSquare from "images/orange-square-quote.svg"

const AsideTestimonial = ({ content }) => {
  return (
    <ContentWidth>
      <Wrapper>
        <QuoteContainer Bg={content.quoteCardBackground}>
          <QuoteImg src={QuoteSquare} alt="" />
          <BlockQuote>{content.quoteBody}</BlockQuote>
          <Person>{content.personQuoted}</Person>
        </QuoteContainer>
        {content.callout ? (
          <ContentContainer>
            <Eyebrow>{content?.quoteEyebrow}</Eyebrow>
            <Header>{content?.headline}</Header>
            <Body>{content?.body}</Body>
            <Link href={content?.linkCta}>{content?.linkText}</Link>
          </ContentContainer>
        ) : (
          <CompanyImage
            alt={content?.image?.altText}
            src={content.image.sourceUrl}
          />
        )}
      </Wrapper>
    </ContentWidth>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 9.167vw;

  ${media.fullWidth} {
    gap: 132px;
  }
  ${media.tablet} {
    gap: 7.813vw;
  }
  ${media.mobile} {
    flex-direction: column-reverse;
    gap: 14.019vw;
  }
`
const QuoteContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${props => `#${props.Bg}`};
  gap: 1.111vw;
  border-radius: 1.667vw;
  padding: 2.778vw 2.222vw;
  width: 31.111vw;

  ${media.fullWidth} {
    gap: 16px;
    border-radius: 24px;
    padding: 40px 32px;
    width: 448px;
  }
  ${media.tablet} {
    width: 39.063vw;
    gap: 1.563vw;
    border-radius: 2.344vw;
    padding: 3.906vw 3.125vw;
  }
  ${media.mobile} {
    width: 90vw;
    gap: 3.738vw;
    border-radius: 5.607vw;
    padding: 9.346vw 7.477vw;
    margin: 0 auto;
  }
`
const QuoteImg = styled.img`
  width: 5.556vw;
  height: 5.556vw;
  margin-top: -5.556vw;

  ${media.fullWidth} {
    width: 80px;
    height: 80px;
    margin-top: -80px;
  }
  ${media.tablet} {
    width: 7.813vw;
    height: 7.813vw;
    margin-top: -7.813vw;
  }
  ${media.mobile} {
    width: 18.692vw;
    height: 18.692vw;
    margin-top: -18.692vw;
  }
`
const BlockQuote = styled.blockquote`
  ${text.bodyLg};
`
const Person = styled.p`
  ${text.bodyMd};
  text-align: left;
`
const CompanyImage = styled.img`
  width: 39.167vw;

  ${media.fullWidth} {
    width: 564px;
  }

  ${media.tablet} {
    width: 45.313vw;
  }

  ${media.mobile} {
    width: 70.561vw;
    margin: 0 auto;
  }
`
const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.111vw;
  width: 39.167vw;

  ${media.fullWidth} {
    gap: 16px;
    width: 564px;
  }
  ${media.tablet} {
    width: 45.313vw;
    gap: 1.563vw;
  }
  ${media.mobile} {
    width: 87.85vw;
    gap: 3.738vw;
  }
`
const Eyebrow = styled.p`
  ${text.eyebrow};

  ${media.mobile} {
    ${text.eyebrow};
  }
`
const Header = styled.h3`
  ${text.h3};

  ${media.mobile} {
    ${text.h3};
  }
`
const Body = styled.p`
  ${text.bodyMd};
`
const Link = styled.a`
  ${text.bodyMdBold}
  text-align: left;
  color: ${colors.primaryOrange};

  ${media.hover} {
    :hover {
      text-decoration: underline;
      text-underline-offset: 3px;
    }
  }
`

export default AsideTestimonial
